import React, {useEffect, useState} from "react";
import {apiConfig} from "../../../../config";
import axios from "axios";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import {ClipLoader} from "react-spinners";


const COLUMNS_STORAGE_KEY = "operator_stat_columns";

type Column = {
  key: string;
  label: string;
  visible: boolean;
};


const DEFAULT_COLUMNS: Column[] = [
  { key: "date", label: "Оператор", visible: true },
  { key: "in_call", label: "Время разговоров", visible: true },
  { key: "moved_away", label: "Отошел", visible: true },
  { key: "ready", label: "Ожидание звонка", visible: true },
  { key: "wait_lead", label: "Заполнение лида", visible: true },
  { key: "education", label: "Обучение", visible: true },
  { key: "all_time", label: "Всего на смене", visible: true },
  { key: "in_work", label: "В работе", visible: true },
  { key: "leads", label: "Кол-во лидов", visible: true },
  { key: "paid_responses", label: "Оплаченные отклики", visible: true },
  { key: "calls_more_1_min", label: "Звонки > 1 мин", visible: true },
  { key: "all_answered_calls", label: "Обработанные звонки", visible: true },
  { key: "ao_calls", label: "АО процент", visible: true },
  { key: "avg_ready", label: "Ср. время ожидания", visible: true },
  { key: "ao_calls_num", label: "АО кол-во", visible: true },
  { key: "avg_ao_duration", label: "Ср. время АО", visible: true },
];

// Сохранённые настройки столбцов дополняем новыми столбцами, иначе у админов с сохранённым
// порядком новый столбец не появится. Новый встаёт после своего соседа слева.
const mergeColumns = (saved: Column[]): Column[] => {
  const result = saved.filter(c => DEFAULT_COLUMNS.some(d => d.key === c.key));
  DEFAULT_COLUMNS.forEach((column, index) => {
    if (result.some(c => c.key === column.key)) return;
    const prevKey = index > 0 ? DEFAULT_COLUMNS[index - 1].key : null;
    const prevIndex = result.findIndex(c => c.key === prevKey);
    result.splice(prevIndex + 1, 0, {...column});
  });
  return result;
};

export const OperatorStatComp = (props: any) => {
  const [responseOperatorsStat, setResponseOperatorsStat]: [any, any] = useState(null)
  const [selectOperator, setSelectOperator]: [any, any] = useState(null)
  const [selectOperatorsAll, setSelectOperatorsAll]: [any, any] = useState([])
  const [startDate, setStartDate]: [any, any] = useState(new Date().setHours(0, 0));

  const [columns, setColumns] = useState<Column[]>(() => {
    const saved = localStorage.getItem(COLUMNS_STORAGE_KEY);

    if (saved) {
      try {
        return mergeColumns(JSON.parse(saved) as Column[]);
      } catch {
        /* ignore */
      }
    }

    return DEFAULT_COLUMNS.map(c => ({...c}));
  });

  const currentDate: any = (new Date())
  currentDate.setDate(currentDate.getDate() + 1);
  const [endDate, setEndDate]: [any, any] = useState(currentDate.setHours(0,0,0));

  const [loading, setLoading] = useState(false)

  const getUsers = async () => {
    const config = {
      method: 'get',
      url: `${apiConfig.url}/auth/list`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      }
    };
    try {
      return await axios(config);
    } catch (error) {
      return {
        data: []
      }
      console.error('error', error);
    }
  }

  const  getOperatorsStat = async ()=> {
    setLoading(true)

    let tzoffset = (new Date()).getTimezoneOffset() * 60000;

    let startDateNormal = startDate ? (new Date(startDate - tzoffset)).toISOString() : null
    let endDateNormal = endDate ? (new Date(endDate - tzoffset)).toISOString() : null

    console.log(startDateNormal, endDateNormal)

    const config = {
      method: 'get',
      url: `${apiConfig.url}/statistic/users`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token_caltatToki')}`
      },
      params: {
        user_id: selectOperator ? selectOperator.value : null,
        date_from: startDateNormal,
        date_to: endDateNormal,
      }
    };
    try {
      const response = await axios(config);
      console.log(response)

      let response_users= await getUsers()
      let operatorsOptions = [
        {value: null, label: "Без оператора"}
      ]

      for (let i = 0; i < response_users.data.length; i++) {
        operatorsOptions.push(
          {value: response_users.data[i].id, label: response_users.data[i].name}
        )
      }
      setSelectOperatorsAll(operatorsOptions)

      setResponseOperatorsStat(response.data)

      setLoading(false)
    } catch (error) {
      console.error('error', error);
    }
  }

  let users_stats = []
  if (responseOperatorsStat) {
    let respUsers = responseOperatorsStat
    for(let y=0; y<respUsers.length; y++) {
      let byDays = []
      let respByDays = respUsers[y].daily_stat
      for(let z=0; z<respByDays.length; z++) {
        let ob_key = Object.keys(respByDays[z])[0]
        byDays.push(
          <tr style={{fontSize: 15, textAlign: 'center'}}>
            {columns.filter(c => c.visible).map(col => {
              switch (col.key) {
                case "date":
                  return <td key={col.key}>{ob_key}</td>

                case "in_call":
                  return <td key={col.key}>{respByDays[z][ob_key].in_call.time}</td>

                case "moved_away":
                  return <td key={col.key}>{respByDays[z][ob_key].moved_away.time}</td>

                case "ready":
                  return <td key={col.key}>{respByDays[z][ob_key].ready.time}</td>

                case "wait_lead":
                  return <td key={col.key}>{respByDays[z][ob_key].wait_lead.time}</td>

                case "education":
                  return <td key={col.key}>{respByDays[z][ob_key].education.time}</td>

                case "all_time":
                  return <td key={col.key}>{respByDays[z][ob_key].all_time.time}</td>

                case "in_work":
                  return <td key={col.key}>{respByDays[z][ob_key].in_work.time}</td>

                case "leads":
                  return <td key={col.key}>{respByDays[z][ob_key].leads}</td>

                case "paid_responses":
                  return <td key={col.key}>{respByDays[z][ob_key].paid_responses ?? 0}</td>

                case "calls_more_1_min":
                  return <td key={col.key}>{respByDays[z][ob_key].calls_more_1_min}</td>

                case "all_answered_calls":
                  return <td key={col.key}>{respByDays[z][ob_key].all_answered_calls}</td>

                case "ao_calls":
                  return <td key={col.key}>{respByDays[z][ob_key].ao_calls?.toFixed(2)}{respByDays[z][ob_key].ao_calls ? '%' : ''}</td>

                case "avg_ready":
                  return <td key={col.key}>{respByDays[z][ob_key]?.avg_ready?.toFixed(2)}</td>

                case "ao_calls_num":
                  return <td key={col.key}>{respByDays[z][ob_key]?.ao_calls_num?.toFixed(0)}</td>

                case "avg_ao_duration":
                  return <td key={col.key}>{respByDays[z][ob_key]?.avg_ao_duration?.toFixed(2)}</td>

                default:
                  return null
              }
            })}
          </tr>
        )
      }
      users_stats.push(
        <div style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          borderWidth: 1,
          marginBottom: 10,
          marginTop: 10, backgroundColor: "rgb(246 246 251)"
        }}>
          <div style={{fontSize: 19, marginLeft: 5}}>
            {respUsers[y].created_at.split("T")[0]}
          </div>
          <div style={{display: "flex", flexDirection: "column"}}>
            <table style={{width: "100%", borderTopWidth: 1}}>
              <tr>
                {columns.filter(c => c.visible).map(col => (
                  <th style={{fontSize: 16}} key={col.key}>{col.label}</th>
                ))}
              </tr>
              {byDays}
            </table>
          </div>
        </div>
      )
    }
  }

  useEffect(() => {
    getOperatorsStat()
  }, [])


  useEffect(() => {
    localStorage.setItem(
      COLUMNS_STORAGE_KEY,
      JSON.stringify(columns)
    );
  }, [columns]);

  return (
    <div style={{display: "flex", flex: 1, flexDirection: "column", overflow: "auto", paddingRight: 20, paddingLeft: 20}}>
      <div style={{display: "flex", flexDirection: "row", paddingTop: 20, paddingBottom: 20, alignItems: "center"}}>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginRight: 20}}>
          <div style={{marginRight: 10}}>
            Оператор:
          </div>
          <Select
            onChange={(item) => {
              setSelectOperator(item)
            }}
            options={selectOperatorsAll}
          />
        </div>
        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
          <div>
            Дата от:
          </div>

          <div style={{display: "flex", marginRight: 20, marginLeft: 10}}>
            <DateTimePicker
              onChange={(date: any) => {
                date ? setStartDate(new Date(date)) : setStartDate(null)
              }}
              value={startDate}
              disableClock={true}
            />
          </div>
          <div>
            Дата до:
          </div>
          <div style={{display: "flex", marginLeft: 10}}>
            <DateTimePicker
              onChange={(date: any) => {
                date ? setEndDate(new Date(date)) : setEndDate(null)
              }}
              value={endDate}
              disableClock={true}
            />
          </div>
        </div>
        <button
          onClick={() => {
            getOperatorsStat()
          }}
          style={{
            display: "flex",
            height: 40,
            borderRadius: 5,
            justifyContent: "center",
            alignItems: 'center',
            borderWidth: 1,
            borderColor: "black",
            marginLeft: 60
          }}>
          Применить фильтр
        </button>
      </div>
      <div style={{position: 'relative', display: "flex", flex: 1, flexDirection: "column"}}>
        <div style={{display: "flex", flexWrap: "wrap", marginBottom: 20}}>
          {columns.map((col, idx) => (
            <label key={col.key} style={{marginRight: 10, fontSize: 14}}>
              <input
                style={{marginRight: 5}}
                type="checkbox"
                checked={col.visible}
                onChange={() => {
                  const next = [...columns]
                  next[idx].visible = !next[idx].visible
                  setColumns(next)
                }}
              />
              {col.label}
            </label>
          ))}
        </div>
        {users_stats}
        {loading &&
            <div style={{
              fontSize: 30,
              position: "absolute",
              width: "100%",
              height: "100%",
              // backgroundColor: "rgba(100, 100, 100, 0.2)",
              color: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: 'center',
            }}>
                <ClipLoader size={150} color={"black"}/>
            </div>
        }
      </div>
    </div>
  )
}
